import {httpMethod} from '@di-nxt/resource-container/src/api/fetchers';
import {ApiMode, FailureRate} from '@di-nxt/resource-container/src/types';
import {AuthTokens} from './types';
import {hasTokenExpired} from './functions';
import {HttpError} from '@di-nxt/resource-container/src/api/types';

let mockCount = 0;

type ApiConfig = {
  baseUrl: string;
  endPoint: string;
  mode: ApiMode;
  mockFailureRate?: FailureRate;
  mockFactory: () => AuthTokens;
};

const delayedPromiseResolve = <T>(dataFactory: () => T): Promise<T> => {
  return new Promise<T>(resolve => {
    setTimeout(() => resolve(dataFactory()), 500);
  });
};

const delayedPromiseReject = <T>(error: HttpError): Promise<T> => {
  return new Promise<T>((_, reject) => {
    setTimeout(() => reject(error), 500);
  });
};

// TODO: coordinate parallel req, i.e. return same promise.

let activePromise: Promise<AuthTokens | undefined> | undefined;

export const createRefreshTokensApi = (config: ApiConfig) => {
  return (refreshToken: string): Promise<AuthTokens | undefined> => {
    if (activePromise) {
      // console.log('*******createRefreshTokensApi: return active promise');
      return activePromise;
    }

    if (config.mode === 'mock') {
      mockCount += 1;

      if (hasTokenExpired(refreshToken)) {
        activePromise = delayedPromiseReject(
          new HttpError(
            401,
            '/mock/login/refresh',
            'Mock: Refresh token has expired',
          ),
        );
      } else if (
        config.mockFailureRate !== undefined &&
        mockCount % config.mockFailureRate === 0
      ) {
        activePromise = delayedPromiseReject(
          new HttpError(
            500,
            '/mock/login/refresh',
            'Mock should fail: Refresh token failed',
          ),
        );
      } else {
        activePromise = delayedPromiseResolve(config.mockFactory);
      }
    } else {
      activePromise = httpMethod<AuthTokens>({
        method: 'GET',
        baseUrl: config.baseUrl,
        endPoint: config.endPoint,
        extraHeaders: {
          'Refresh-Token': refreshToken,
        },
        responseAsJson: true,
      });
    }

    return activePromise!.finally(() => {
      activePromise = undefined;
    });
  };
};
